<!--
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2023-12-27 15:17:55
 * @FilePath: /smartEarthDemo/src/demo/modelEffect/56modelBorder.vue
 * @Description: 
-->
<template>
    <div style="height:100%;">
        <div id="csContainer"></div>
    </div>
</template>

<script>
    import util from "../../components/util"

    export default {
        data() {
            return {
                vw: null,
                entity: null,
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                let vw = util.getViewer("csContainer");
                this.vw = vw;
                this._createModel();
            },
            _createModel() {
                let viewer = this.vw;
                let url = "/demo/static/data/models/people.glb";
                let height = 0;
                viewer.entities.removeAll();

                let position = Cesium.Cartesian3.fromDegrees(-123.0744619, 44.0503706, height);
                let heading = Cesium.Math.toRadians(135);
                let pitch = 0;
                let roll = 0;
                let hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
                let orientation = Cesium.Transforms.headingPitchRollQuaternion(position, hpr);

                let entity = viewer.entities.add({
                    name: url,
                    position: position,
                    orientation: orientation,
                    model: {
                        uri: url,
                        minimumPixelSize: 128,
                        maximumScale: 20000,
                        silhouetteColor: Cesium.Color.BLUE,
                        silhouetteSize: 6,
                        scale:0.01
                    }
                });
                this.entity = entity;
                viewer.trackedEntity = entity;
            },
        }
    }
</script>

<style scoped>
    #csContainer {
        height: 100%;
    }
</style>
